// src/utils/objectUtils.js

export function pick(obj, allowedFields) {
    return allowedFields.reduce((acc, field) => {
      if (obj[field] !== undefined) {
        acc[field] = obj[field];
      }
      return acc;
    }, {});
  }
  